import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ctm-components';
import { pageContext } from 'ctm-util-functions';
import { useStyles } from './prefill_styles';

const PrefillQuoteCTAButtons = (props) => {
    const { continueDisabled, startNewQuote, resumeQuoteFunc, showNewQuoteButton } = props;
    const vertical = pageContext.getVertical();

    const classes = useStyles({ vertical });

    return (
        <div className={classes.quoteButtonWrapper}>
            <div className={showNewQuoteButton ? classes.prefillButtonWrapper : classes.prefillButtonWrapperHidden}>
                {
                    showNewQuoteButton &&
                        <Button
                            id="prefillVerify.startNewQuoteButton"
                            UIComponent="btn_primary_transparent_xlarge_rounded"
                            onClick={startNewQuote}
                            variant="full_width"
                            label="Start New Quote"
                        />
                }
                <Button
                    id="prefillVerify.resumeQuoteButton"
                    icon="ctm_arrow_right"
                    UIComponent={continueDisabled
                        ? 'btn_secondary_xlarge_semi_rounded_disabled'
                        : 'btn_secondary_xlarge_semi_rounded'}
                    onClickFunction={resumeQuoteFunc}
                    variant="full_width"
                    label="Resume Quote"
                />
            </div>
            {!showNewQuoteButton &&
                <p className={classes.subtext}>Alternatively, you can <a className={classes.linkText} onClick={startNewQuote}>start a new quote.</a></p>
            }
        </div>
    );
};

PrefillQuoteCTAButtons.propTypes = {
    continueDisabled: PropTypes.bool.isRequired,
    showNewQuoteButton: PropTypes.bool.isRequired,
    startNewQuote: PropTypes.func.isRequired,
    resumeQuoteFunc: PropTypes.func.isRequired
};

export { PrefillQuoteCTAButtons };
